<template>
  <v-app class="bdy">
    <!--<Loader/>-->

    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <img src="./assets/logonobg.png" class="images">
      </div>

      <v-spacer></v-spacer>

      <v-btn
        href="https://wa.me/260958168829"
        target="_blank"
        text
      >
        <span class="mr-2">Help!</span>
        <img src="./assets/headphone (1).png" class="help">
      </v-btn>
    </v-app-bar>

    <v-main>
      <!--<Loader/>-->
      <!--<BookingApp/> this is left here for testing purposes-->
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
//import Loader from "@/components/layout/Loader";
//import routeExceptions from "core-js/internals/array-includes";
//import BookingApp from './components/ErrorPage.vue';

export default {
  name: 'App',
  components: {
    //Loader,
    //BookingApp
  },
  /*beforeMount() {

    if (!routeExceptions.includes(this.$route.name)) {
      this.$store.dispatch('syncData');
    }
  },*/
  computed : {
    /*loading(){
      return this.$store.getters.getLoadingState;
    }*/
  },

  data: () => ({
    //
  }),
};
</script>

<style>
body {
  display: flex;
  align-items: center;
  justify-content: center;
}

.images {
  height: 50px;
  width: 50px;
}
.help {
  height: 30px;
  width: 30px;
}
</style>
